// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/bugreport/v1/bugreport.proto (package mono.bugreport.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CreateBugReportRequest, CreateBugReportResponse, DraftBugReportRequest, DraftBugReportResponse, ListBugReportsRequest, ListBugReportsResponse } from "./bugreport_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * BugReportService is the in-app "report a bug" flow, replacing express's
 * /api/bug-report.
 *
 * Jira is the system of record. express kept a parallel Mongo row per report
 * and read the list back from it, which meant two stores to keep honest for
 * data Jira already held — the row's own fields were the ticket's summary,
 * description and key. Here the issue IS the record: creating a report creates
 * the issue, and listing reports searches for them.
 *
 * mainmast serves this because it already holds Jira credentials and a client.
 * It is a separate service rather than more surface on DeployControlService
 * because a user reporting a bug has nothing to do with deploy control; only
 * the plumbing is shared.
 *
 * @generated from service mono.bugreport.v1.BugReportService
 */ export const BugReportService = {
    typeName: "mono.bugreport.v1.BugReportService",
    methods: {
        /**
     * Files a bug as a Jira issue, attaching the screenshot and app state when
     * the reporter included them.
     *
     * @generated from rpc mono.bugreport.v1.BugReportService.CreateBugReport
     */ createBugReport: {
            name: "CreateBugReport",
            I: CreateBugReportRequest,
            O: CreateBugReportResponse,
            kind: MethodKind.Unary
        },
        /**
     * Turns a spoken report into a draft: the transcript, plus a title and a
     * cleaned-up description written from it. Nothing is filed — the reporter
     * reviews the draft first, because a mis-heard word is cheap to fix in a
     * form and expensive to fix in a ticket someone has already triaged.
     *
     * @generated from rpc mono.bugreport.v1.BugReportService.DraftBugReport
     */ draftBugReport: {
            name: "DraftBugReport",
            I: DraftBugReportRequest,
            O: DraftBugReportResponse,
            kind: MethodKind.Unary
        },
        /**
     * Lists previously filed reports, newest first.
     *
     * @generated from rpc mono.bugreport.v1.BugReportService.ListBugReports
     */ listBugReports: {
            name: "ListBugReports",
            I: ListBugReportsRequest,
            O: ListBugReportsResponse,
            kind: MethodKind.Unary
        }
    }
};
